import { CommonModule } from '@angular/common';
import { NgModule } from '@angular/core';
import { ReMultiselectModule } from '@common/re-multiselect/re-multiselect.module';
import { PipeDirectiveModule } from '@shared-modules/pipe-directive.module';
import { ListingPrimeNgModule } from '../../my-listings/listing-primeNg.module';
import { CreateNewTaskComponent } from './create-new-task.component';

@NgModule({
  declarations: [CreateNewTaskComponent],
  imports: [CommonModule, ListingPrimeNgModule, PipeDirectiveModule, ReMultiselectModule],
  exports: [CreateNewTaskComponent],
})
export class CreateTaskModule {}
